import { FC } from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import SvgIcon from '@/components/SvgIcon';
import styles from './index.module.scss';

interface ContactFailModalProps {
  open: boolean;
  onCancel: () => void;
  onRetry: () => void;
}

const ContactFailModal: FC<ContactFailModalProps> = ({ open, onCancel, onRetry }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onCancel={onCancel} closeIcon={<SvgIcon name="x-black" size={16} />} footer={null} centered width={400} className={styles.contactFailModal}>
      <div className={styles.content}>
        {/* Warning Icon */}
        <div className={styles.iconWrapper}>
          <SvgIcon name="warning" size={76} />
        </div>

        {/* Title */}
        <h3 className={styles.title}>{t('contactUs.failModal.title')}</h3>

        {/* Description */}
        <p className={styles.description}>
          {t('contactUs.failModal.description')}{' '}
          <a href="mailto:dev@thepatch.ai" className={styles.emailLink}>
            dev@thepatch.ai
          </a>
        </p>

        {/* Action Buttons */}
        <div className={styles.actions}>
          <Button className="btn-secondary" onClick={onCancel}>
            {t('contactUs.failModal.cancel')}
          </Button>
          <Button type="primary" size="large" onClick={onRetry}>
            {t('contactUs.failModal.retry')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ContactFailModal;
